import React from 'react';
export function TeamSection() {
  return <section className="bg-[#F8F6F2] py-20 md:py-28" data-id="element-165">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-166">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-167">
          {/* Left: Text */}
          <div className="w-full lg:w-1/2 flex flex-col justify-center" data-id="element-168">
            <span className="text-[#C8A84E] text-sm tracking-[0.2em] uppercase font-semibold mb-4 block" style={{
            fontFamily: "'Montserrat', sans-serif"
          }} data-id="element-169">
              Meet Your Provider
            </span>

            <h2 className="text-3xl md:text-4xl lg:text-5xl text-[#1A1A1A] mb-6 leading-tight" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-170">
              Passionate About Your Glow
            </h2>

            <p className="text-[#1A1A1A]/80 text-base md:text-lg mb-8 leading-relaxed" style={{
            fontFamily: "'Montserrat', sans-serif"
          }} data-id="element-171">
              Our founder is a Registered Nurse, holding an MS and Certified
              Aesthetic Nurse Injector credential, currently pursuing her FNP.
              She built Raise The Bar with a deep love for aesthetics and a
              mission to help every client enhance their natural beauty with
              confidence. We believe in community over competition, continuing
              education, and always bringing the newest techniques and safest
              treatments to Gilbert, AZ.
            </p>

            <div data-id="element-172">
              <a href="#story" className="inline-flex items-center text-[#C8A84E] font-semibold hover:underline underline-offset-4 transition-all min-h-[48px]" style={{
              fontFamily: "'Montserrat', sans-serif"
            }} data-id="element-173">
                Read Our Story <span className="ml-2" data-id="element-174">→</span>
              </a>
            </div>
          </div>

          {/* Right: Image */}
          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end" data-id="element-175">
            <div className="relative" data-id="element-176">
              <div className="absolute inset-0 rounded-full border-4 border-[#C8A84E] transform translate-x-4 translate-y-4 opacity-50" data-id="element-177"></div>
              <img src="https://cdn.magicpatterns.com/uploads/aCtpbZULWtLdRHFKyZPT1i/raise_the_bar_june_2024-91.jpg" alt="Provider Headshot" className="relative z-10 w-64 h-64 md:w-80 md:h-80 rounded-full object-cover ring-4 ring-[#C8A84E] shadow-2xl" data-id="element-178" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}